import type { ReactNode } from 'react';
import Eyebrow from '../atoms/Eyebrow';

interface PageHeaderProps {
  eyebrow?: string;
  eyebrowTone?: 'vermilion' | 'azure' | 'ink' | 'ash';
  title: ReactNode;
  sub?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

// PR-UX-01 70/30 · header keeps title visually dominant; secondary actions on right.
// PR-UX-08 organism · single header pattern, used by every authed route.
export default function PageHeader({
  eyebrow,
  eyebrowTone = 'vermilion',
  title,
  sub,
  actions,
  className = '',
}: PageHeaderProps) {
  return (
    <header className={`mb-12 ${className}`}>
      <div className="flex items-start justify-between gap-6 mb-3">
        <div>
          {eyebrow && <Eyebrow tone={eyebrowTone} className="mb-3">{eyebrow}</Eyebrow>}
          <h1 className="font-serif text-4xl md:text-5xl font-medium tracking-tight leading-tight">
            {title}
          </h1>
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </div>
      {sub && <p className="text-base text-ink-2 max-w-xl leading-relaxed">{sub}</p>}
    </header>
  );
}
